<script setup>
import api from "../api/api";
import ButtonSubmit from "./ButtonSubmit.vue";
import moment from "moment-timezone";
import BaseButton from "./UI/BaseButton.vue"
import { readDate } from '../utils/timezone.js';

</script>

<template>
  <ButtonSubmit 
    label="Refresh"
    type="submit"
    style="margin-bottom: 10px;"
    @click="getData()"
  />

  <div v-if="isLoading">Loading...</div>
    <v-data-table
      :headers="headers"
      :items="filteredAdminDashboard"
      item-key="ind_id"
      id="table"
      :items-per-page="pagination.itemsPerPage"
      v-model:pagination="pagination"
      v-model:page="pagination.page"
    >

      <template v-slot:headers>
          <tr>
            <th class="v-data-table__td v-data-table-column--align-start v-data-table__th--sortable v-data-table__th"
              v-for="header in headers"
              :key="header.key"
              :style="{ backgroundColor: brandData.main_color2 }"
            >
            <a
            @click="sortByHeader(header.key, individualData)"
            style="
              display: flex;
              flex-direction: row;
              cursor: pointer;
            ">
              {{ getHeaderLabel(header.key) }}
              <div class="sort-icon" :class="{ active: sortColumn === header.key }">
                <a v-if="sortDirection === 'asc' && sortColumn === header.key">
                  <i class="fa-solid fa-sort-down"></i>
                </a>
                <a v-else-if="sortDirection === 'desc' && sortColumn === header.key">
                  <i class="fa-solid fa-sort-up"></i>
                </a>
              </div>
            </a>
            </th>
          </tr>
          <tr>
            <td>
              <div class="input-container">
                <input
                type="text"
                placeholder="org..."
                v-model="searchOrg"
                />
              </div>
            </td>
            <td>
              <div class="input-container">
                <input
                  type="textarea"
                  placeholder="email..."
                  style=""
                  v-model="searchEmail"
                />
              </div>
            </td>
            <td>
              <div class="input-container">
                <input
                  type="text"
                  placeholder="logged-in..."
                  style="min-width: 10px"
                  v-model="searchLoggedIn"
                />
              </div>
            </td>
            <td>
              <div class="input-container">
                <input
                  type="text"
                  placeholder="startup screen..."
                  style=""
                  v-model="searchStartupScreen"
                />
              </div>
            </td>
            <td>
              <div class="input-container">
                <input
                  type="text"
                  placeholder="first name..."
                  style=""
                  v-model="searchFirstName"
                />
              </div>
            </td>
            <td>
              <div class="input-container">
                <input
                  type="text"
                  placeholder="last name..."
                  style=""
                  v-model="searchLastName"
                />
              </div>
            </td>
            <td>
              <div class="input-container">
                <input
                  type="text"
                  placeholder="roles..."
                  style=""
                  v-model="searchRoles"
                />
              </div>
            </td>
            <td>
              <div class="input-container">
                <input
                  class="input1"
                  type="datetime-local"
                  id="AddedDate"
                  style=""
                  v-model="searchAdded"
                />
              </div>
            </td>
            <td>
              <div class="input-container">
                <input
                  class="input2"
                  type="datetime-local"
                  id="LastLoginDate"
                  style=""
                  v-model="searchLastLogin"
                />
              </div>
            </td>
            <td>
            </td>
          </tr>
      </template>


      <template v-slot:item="{ item }">
        <tr :key="item.ind_id">
          <td>{{ item.organization }}</td>
          <td>{{ item.email }}</td>
          <td>{{ item.logged_in }}</td>
          <td>{{ item.startup_screen }}</td>
          <td>{{ item.first_name }}</td>
          <td>{{ item.last_name }}</td>
          <td>{{ item.roles }}</td>
          <td>{{ readDate(item.added, parsedLoginUp.time_zone) }}</td>
          <td>{{ item.last_login ? readDate(item.last_login, parsedLoginUp.time_zone) : 'N/A' }}</td>
          <td style="text-align: center">
            <BaseButton
              @click="edit(item)"
              class="td-btn btn-submit"
              :disabled="item.ind_id === currentIndID"
            >
              Edit
              <i class="fa-regular fa-edit" aria-hidden="true"></i>
            </BaseButton>
          </td>
        </tr>
      </template>
    </v-data-table>
</template>

<script>
export default {
  name: "AdminDashboardBox",
  components: [ButtonSubmit, BaseButton,],
  props: ["buttonLabel", "userData", "brandData"],
  data: () => ({
  headers: [
      { key: 'organization', title: 'Organization', width: '5%'},
      { key: 'email', title: 'Email', width: '20%'},
      { key: 'logged_in', title: 'Logged-In', width: '10%'},
      { key: 'startup_screen', title: 'Startup Screen', width: '10%'},
      { key: 'first_name', title: 'First Name', width: '10%'},
      { key: 'last_name', title: 'Last Name', width: '10%'},
      { key: 'roles', title: 'Roles', width: '10%'},
      {
        key: 'added',
        title: 'Added',
        sortable: true
        ,width: '10%'
      },
      {
        key: 'last_login',
        title: 'Last Login',
        sortable: true,
        width: '10%'
      },
      { key: 'actions', title: 'Actions', sortable: false, width: '5%'},
    ],
    individualData: [],
    sortDirection: 'asc',
    sortColumn: '',

    searchOrg: '',
    searchEmail: '',
    searchLoggedIn: '',
    searchStartupScreen: '',
    searchFirstName: '',
    searchLastName: '',
    searchRoles: '',
    searchAdded: '',
    searchLastLogin: '',

    localStorageLoginUp: localStorage.getItem("passLoginUp"),
    parsedLoginUp: null,

    isLoading: false,

    pagination: {
      page: 1,
      itemsPerPage: 10,
    },
  }),
  async mounted() {
    try {
        this.parsedLoginUp = JSON.parse(this.localStorageLoginUp);
      } catch (error) {
        console.error("Failed to parse localStorageLoginUp:", error);
      }
    this.lastLoginChecker();
    this.getData();
    await api.get("roles").then((result) => {
      this.roles = result.data
    })
  },
  methods: {
      async lastLoginChecker(){
        try {
          const res = await api.put(`/lastLoginChecker`);
          if (res.status === 200) {
            console.log("success last login updated");
          }
        } catch (error) {
          console.log(error);
        }
      },
      async getData() {
    console.log('Refreshing system...'); // Log for debugging

    try {
      // Clear the existing data to indicate that a refresh is in progress
      this.individualData = [];
      this.isLoading = true; // Assume you have an `isLoading` data property for showing a loading indicator

      // Fetch new data from the API
      const res = await api.get(`/individualsNEW/${this.userData.org_id}`);
      if (res.status === 200) {
        this.individualData = res.data;
        console.log('Data refreshed successfully:', this.individualData);
      } else {
        console.error('Failed to refresh data:', res.status, res.statusText);
      }
    } catch (error) {
      console.error('Error occurred while refreshing data:', error);
    } finally {
      this.isLoading = false; // Hide the loading indicator
    }
  },

    sortByHeader(header, arr) {
      if (header === 'actions') {
        return;
      }
        
      if (this.sortColumn === header) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = header;
        this.sortDirection = 'asc';
      }

      arr.sort((a, b) => {
        if (a[header] < b[header]) {
          return this.sortDirection === 'asc' ? -1 : 1;
        }
        if (a[header] > b[header]) {
          return this.sortDirection === 'asc' ? 1 : -1;
        }
        return 0;
      });
    },
    async edit(data) {
      let dataToPass = [];
        await api
        .get(`individuals/org/${this.userData.org_id}/${localStorage.getItem("companyID")}`)
        .then((result) => {
          dataToPass = result.data.find(item => item.ind_id === data.ind_id);
        })

      this.$router.push({
      name: "CreateEditUserBox",
      query: { data: JSON.stringify(dataToPass) },
      })
    },
    getHeaderLabel(key) {
    const labels = {
      organization: 'Organization',
      email: 'Email',
      logged_in: 'Logged-In',
      startup_screen: 'Startup Screen',
      first_name: 'First Name',
      last_name: 'Last Name',
      roles: 'Roles',
      added: 'Added',
      last_login: 'Last Login',
      actions: 'Actions',
    };
    return labels[key] || key;
  },
  },
  computed: {
     // Inside your computed property filteredAdminDashboard
    filteredAdminDashboard() {
      if (!this.individualData) {
        return [];
      }

      // Convert searchAdded and searchLastLogin to Moment.js objects using readDate
      const searchAdded = this.searchAdded ? readDate(this.searchAdded, this.parsedLoginUp.time_zone) : null;
      const searchLastLogin = this.searchLastLogin ? readDate(this.searchLastLogin, this.parsedLoginUp.time_zone) : null;

      return this.individualData.filter(item => {
        const addedDate = item.added ? readDate(item.added, this.parsedLoginUp.time_zone) : null;
        const lastLoginDate = item.last_login ? readDate(item.last_login, this.parsedLoginUp.time_zone) : null;

        return (
          (this.searchOrg === "" || (item.organization?.toLowerCase() ?? '').includes(this.searchOrg.toLowerCase())) &&
          (this.searchEmail === "" || (item.email?.toLowerCase() ?? '').includes(this.searchEmail.toLowerCase())) &&
          (this.searchLoggedIn === "" || (item.logged_in?.toLowerCase() ?? '').includes(this.searchLoggedIn.toLowerCase())) &&
          (this.searchStartupScreen === "" || (item.startup_screen?.toLowerCase() ?? '').includes(this.searchStartupScreen.toLowerCase())) &&
          (this.searchFirstName === "" || (item.first_name?.toLowerCase() ?? '').includes(this.searchFirstName.toLowerCase())) &&
          (this.searchLastName === "" || (item.last_name?.toLowerCase() ?? '').includes(this.searchLastName.toLowerCase())) &&
          (this.searchRoles === "" || (item.roles?.toLowerCase() ?? '').includes(this.searchRoles.toLowerCase())) &&
          (searchAdded === null || (addedDate && moment(addedDate).isSameOrAfter(searchAdded))) &&
          (searchLastLogin === null || (lastLoginDate && moment(lastLoginDate).isSameOrAfter(searchLastLogin)))
        );
      });
    },
     currentIndID() {
      const passLoginUp = localStorage.getItem('passLoginUp');
      try {
        return JSON.parse(passLoginUp)?.ind_id || null;
      } catch {
        return null;
      }
    },
  }
};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>

<style scoped>
* {
  -webkit-user-select: none; /* Chrome/Safari */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* IE10+ */
  user-select: none;
}
@media only screen and (min-width: 280px) and (max-width: 900px) {
  .body-form-container {
    font-size: 2.5vw;
    background: white;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    position: relative;
    align-items: center;
  }
  #table {
    font-size: 2vw;
    border-collapse: collapse;
    word-break: break-word;
  }
}

.v-table {
  width: 94vw !important;
}

.v-data-table {
  font-size: 1em;
}

#table {
  width: 100%;
  table-layout: auto;
  border-collapse: collapse;
  /* border: 1px solid black; */
}

#table td,
#table th {
  border: 1px solid #ddd !important;
  padding: 8px;
}

#table tr:nth-child(even) {
  background-color: #f2f2f2;
}

#table tr:hover {
  background-color: #ddd;
}

#table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  color: white;
  font-weight: 400;
}

#table td {
  text-align: left;
  vertical-align: middle;
}
#table td input {
  width: 100%;
  box-sizing: border-box; /* include padding and border in width */
}
.sort-icon {
  margin-left: 10px;
}
.input-container input {
  font-size: 16px;
}
</style>
